import { Button } from "antd";
import IconMail from "../../static/icon/Icon_Login_Mail";
// import { version } from "../../../package.json";


export default function ComfirmPage(props) {

  const onFinish = (values) => {
    props.setCurrentPageAction({ name: 'LOGIN', mail: '' })
  };

  return (
    <>
      <div className='justify-center w-150'>
        <div style={{ background: '#FFF4DE' }} className='rounded-xl p-16'>
          <div className='flex items-center'>
            <div>
              <div className="text-3xl font-bold mt-6  ">Email is correct!</div>
              <div className="text-lg text-gray-700 mt-2 mb-10">New password has been sent to {props.currentPageAction.mail} Please insert New password to verify.</div>
              <div>
                <Button
                  className='w-52'
                  size="large"
                  shape="round"
                  type="primary"
                  onClick={onFinish}
                >
                  Ok, got it!
                </Button>
              </div>
            </div>
            <div> <IconMail /></div>
          </div>
        </div>
      </div>
    </>
  );
}
